import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '../../shareds/translate/translate.module';

@Component({
  selector: 'app-select-guest-room',
  imports: [CommonModule,
    FormsModule, TranslateModule],
  templateUrl: './select-guest-room.component.html',
  styleUrls: ['./select-guest-room.component.scss']
})
export class SelectGuestRoomComponent {
  @Input('inputModel')
  set inputModel(v: any) {
    if (!v) return;

    const adults   = Number(v.totalAdultsAmount   ?? 0);
    const children = Number(v.totalChildrenAmount  ?? 0);
    const rooms    = Number(v.totalRoomAmount      ?? 0);

    this.totalAdultsAmount.set(adults);
    this.totalChildrenAmount.set(children);
    this.totalGuestAmount.set(adults + children);
    this.totalRoomAmount.set(rooms);

    // sync listItems ให้ stepper แสดงค่าที่ถูกต้อง
    const adultsItem   = this.listItems.find(i => i.status === 'adults');
    const childrenItem = this.listItems.find(i => i.status === 'children');
    const roomItem     = this.listItems.find(i => i.status === 'room');
    if (adultsItem)   adultsItem.amount   = adults;
    if (childrenItem) childrenItem.amount = children;
    if (roomItem)     roomItem.amount     = rooms;
  }
  @Output('updateItems') updateItemsChange = new EventEmitter<any>();

  listItems = [
    { name: 'ผู้ใหญ่', content: '13 ปีขึ้นไป', status: 'adults', amount: 2 },
    { name: 'เด็ก', content: 'ไม่เกิน 13 ปี', status: 'children', amount: 0 },
    { name: 'ห้องพัก', content: 'ผู้เข้าพักไม่เกิน 6 คน', status: 'room', amount: 1 },
  ]

  add(item: any) {
    item.amount += 1
    this.calculate();
  }

  remove(item: any) {
    if (item.amount == 0) return
    item.amount -= 1
    this.calculate();
  }

  totalAdultsAmount = signal<number>(2);
  totalChildrenAmount = signal<number>(0);
  totalGuestAmount = signal<number>(2);
  totalRoomAmount = signal<number>(1);

  calculate() {
    this.totalGuestAmount.set(0);
    this.totalAdultsAmount.set(0);
    this.totalChildrenAmount.set(0);
    this.totalRoomAmount.set(0);
    this.listItems.filter((fl: any) => fl.status === 'adults').forEach(f => {
      this.totalAdultsAmount.update(v => v + f.amount);
      this.totalGuestAmount.update(v => v + f.amount);

    })
    this.listItems.filter((fl: any) => fl.status === 'children').forEach(f => {
      this.totalChildrenAmount.update(v => v + f.amount);
      this.totalGuestAmount.update(v => v + f.amount);
    })
    this.listItems.filter((fl: any) => fl.status === 'room').forEach(f => {
      this.totalRoomAmount.update(v => v + f.amount);
    })

  }

  toBack() {
    this.updateItemsChange.emit({ status: 'back' })
  }

  submit() {
    if (this.totalGuestAmount() === 0 || this.totalRoomAmount() === 0) return
    this.updateItemsChange.emit({ status: 'update', totalGuestAmount: this.totalGuestAmount(), totalAdultsAmount: this.totalAdultsAmount(), totalChildrenAmount: this.totalChildrenAmount(), totalRoomAmount: this.totalRoomAmount() })
  }
}
